import { resolveRevolveFeatureKind } from './RevolveFeatureKindResolver';
import {FeatureDefinition} from '../FeatureDefinition';

/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/feature/definition/revolve 目录；
 * 2. 负责封装旋转凸台特征的纯数据定义；
 * 3. 该定义对象只保存特征真相，不承担执行、预览或视图逻辑。
 */

/**
 * 旋转特征定义快照。
 */
export interface RevolveFeatureDefinitionSnapshot {
    /** 特征种类。 */
    featureKind: RevolveFeatureKind;
    /** 定义版本。 */
    version: number;
    /** 命令参数。 */
    commandParams: RevolveParams;
}

/**
 * 旋转特征定义模型。
 */
export class RevolveFeatureDefinitionModel extends FeatureDefinition<RevolveFeatureDefinitionSnapshot> {
    /**
     * 从命令参数恢复旋转定义。
     * @param input 输入参数。
     * @returns 旋转定义模型。
     */
    public static fromParams(input: {
        commandParams: RevolveParams;
        featureKind?: RevolveFeatureKind;
        version?: number;
    }): RevolveFeatureDefinitionModel {
        const featureKind = input.featureKind ?? resolveRevolveFeatureKind(input.commandParams);
        return new RevolveFeatureDefinitionModel({
            featureKind,
            version: input.version ?? 1,
            commandParams: {
                ...input.commandParams,
                featureKind,
                operation: featureKind === 'cut-revolve' ? 'cut' : 'boss',
            },
        });
    }

    /**
     * @param snapshot 定义快照。
     */
    public constructor(snapshot: RevolveFeatureDefinitionSnapshot) {
        super(snapshot);
    }

    /**
     * 获取命令参数。
     * @returns 命令参数副本。
     */
    public getCommandParams(): RevolveParams {
        return structuredClone(this.toSnapshot().commandParams);
    }

    /**
     * 获取源草图 ID。
     * @returns 草图 ID；不存在时返回 null。
     */
    public getSourceSketchId(): string | null {
        const sketchId = this.toSnapshot().commandParams.sketchId;
        if (typeof sketchId !== 'string') {
            return null;
        }
        const trimmedSketchId = sketchId.trim();
        return trimmedSketchId.length > 0 ? trimmedSketchId : null;
    }
}
